import * as z from 'zod';

import {
  AchBatchId,
  AchBatchTransactionId,
  BorrowerAchAccountId,
  BorrowerId,
  CompanyAchAccountId,
  CompanyId,
  LoanId,
  UserId,
} from '../BrandedIds';
import { Actor } from '../events/BaseLoanEvent';

export const AchBatchStatus = z.enum(['PENDING', 'FILE_CREATED', 'SUBMITTED_TO_BANK', 'ARCHIVED']);
export type AchBatchStatus = z.infer<typeof AchBatchStatus>;

export const BatchType = z.enum(['ACH', 'PRENOTE']);
export type BatchType = z.infer<typeof BatchType>;

export const AchCode = z.enum(['WEB', 'PPD', 'TEL', 'CCD']);
export type AchCode = z.infer<typeof AchCode>;

export interface AchBatchTransaction {
  id: AchBatchTransactionId;
  achBatchId: string | null;
  borrowerId: BorrowerId;
  loanId: LoanId;
  borrowerAchAccountId: BorrowerAchAccountId;
  companyAchAccountId: CompanyAchAccountId;
  amount: number;
  status: string;
  achCode: string;
  description: string;
  prenote: boolean;
  recurring: boolean;
  processedAt?: Date;
  cancelledAt?: Date;
  cancelledBy?: Actor;
  failedAt?: Date;
  failedBy?: Actor;
  failureCode?: string;
  /**
   * 15-digit NACHA trace number assigned to this transaction's debit entry
   * when its AchBatch's NACHA file was generated. Used to match incoming
   * NACHA Return files back to the originating Willow transaction.
   * Undefined until the batch's file has been generated, and undefined on
   * rows that pre-date the column.
   */
  traceNumber?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface AchBatch {
  id: AchBatchId;
  companyId: CompanyId;
  fileIdModifier: string;
  batchDate: Date;
  status: AchBatchStatus;
  batchType: string;
  s3Url?: string;
  achBatchTransactions: AchBatchTransaction[];
  createdByUserId: UserId;
  archivedAt?: Date;
  archivedBy?: Actor;
  createdAt: Date;
  updatedAt: Date;
}
